import { render, staticRenderFns } from "./OneWishlistIconComponent.vue?vue&type=template&id=488fdb8f&scoped=true&lang=pug&"
import script from "./OneWishlistIconComponent.vue?vue&type=script&lang=ts&"
export * from "./OneWishlistIconComponent.vue?vue&type=script&lang=ts&"
import style0 from "./OneWishlistIconComponent.vue?vue&type=style&index=0&id=488fdb8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488fdb8f",
  null
  
)

export default component.exports